import { ImagePallete1,ImagePallete2, ImagePallete3, ImagePallete4, ImagePallete5, ImagePallete6 } from "../assets";
  export const NavbarList = [
    {
      text: "Strona główna",
      alt: "Home-icon",
      icon: "gg-home",
      link: "#Home"
    },
    {
      text: "Paleta strony",
      alt: "ColorPallete-icon",
      icon: "gg-color-bucket mr-[13px]",
      link: "#UXPsys"
    },
    {
      text: "O nas",
      alt: "Aboutus-icon",
      icon: "gg-feed mr-[13px]",
      link: "#Aboatme"
    },
    {
      text: "Kreator wyboru",
      alt: "SelectionChoose",
      icon: "gg-board",
      link: "#Offer"
    },
  ];
  export const LetterList = [
    {
      text: "t",
      semiID: "letter_0",

    },
    {
      text: "e",
      semiID: "letter_1",

    },
    {
      text: "c",
      semiID: "letter_2",

    },
    {
      text: "h",
      semiID: "letter_3",

    },
    {
      text: "n",
      semiID: "letter_4",

    },
    {
      text: "o",
      semiID: "letter_5",

    },
    {
      text: "l",
      semiID: "letter_6",

    },
    {
      text: "o",
      semiID: "letter_7",

    },
    {
      text: "g",
      semiID: "letter_8",

    },
    {
      text: "i",
      semiID: "letter_9",

    },
    {
      text: "i",
      semiID: "letter_10",

    },
    {
      text: ".",
      semiID: "letter_11",

    },

  ];



  export const NavbarProfile = [
    {
      text: "Część Startowa",
      alt: "Home-icon",
      icon: "gg-home-alt",
      link: "#Start",
    },
    {
      text: "Konfigurator",
      alt: "Configurate-icon",
      icon: "gg-ui-kit mr-[6px]",
      link: "#Config",

    },
    {
      text: "Ustawienia",
      alt:  "Settings-icon",
      icon: "gg-toggle-off",
      link: "#Settings",

    },
    {
      text: "Pomoc",
      alt: "Help-icon",
      icon: "gg-ghost-character",
      link: "#Help",

    },
  ];


  export const Offer1 = [
    {
      title: "System logowania",
      check: 0,
    },
    {
      title: "Support developerów - 4 mies ",
      check: 1,
    },
    {
      title: "Animacje grafik (.gif) - 2 max ",
      check: 1,
    },
    {
      title: "System cms",
      check: 0,
    },
    {
      title: "Analityka google",
      check: 1,
    },
    {
      title: "Dostep do plików (in real time)",
      check: 1,
    },
    {
      title: "Pozycjonowanie",
      check: 1,
    },
  ];
  export const Offer2 = [
    {
      title: "System logowania",
      check: 0,
    },
    {
      title: "Support developerów - 4 mies ",
      check: 1,
    },
    {
      title: "Animacje grafik (.gif) - 2 max ",
      check: 1,
    },
    {
      title: "System cms",
      check: 1,
    },
    {
      title: "Analityka google",
      check: 1,
    },
    {
      title: "Dostep do plików (in real time)",
      check: 1,
    },
    {
      title: "Pozycjonowanie",
      check: 1,
    },
  ];
  export const Offer3 = [
    {
      title: "System logowania",
      check: 1,
    },
    {
      title: "Support developerów - 4 mies ",
      check: 1,
    },
    {
      title: "Animacje grafik (.gif) - 2 max ",
      check: 1,
    },
    {
      title: "System cms",
      check: 1,
    },
    {
      title: "Analityka google",
      check: 1,
    },
    {
      title: "Dostep do plików (in real time)",
      check: 1,
    },
    {
      title: "Pozycjonowanie",
      check: 1,
    },
    {
      title: "Tłumaczenie na wybrane języki",
      check: 1,
    },
  ];
  export const Pallete0 = [
    "#8294C4","#ACB1D6","#DBDFEA","#FFEAD2"
    ];

  export const Pallete1 = [
      "#967E76","#D7C0AE","#B7C4CF","#EEE3CB"
  ];

  export const Pallete2 = [
    "#577D86","#569DAA","#87CBB9","#B9EDDD"
  ];

  export const Pallete3 = [
    "#4A55A2","#7895CB","#A0BFE0","#C5DFF8"
  ];
  
  export const Pallete4 = [
    "#748DA6","#9CB4CC","#D3CEDF","#F2D7D9"
  ];
  export const Pallete5 = [
    "#9BCDD2","#FF8551","#FFDEDE","#FAF0E4"
  ];

  export const Pallets = [
    {
      image: [ImagePallete1],
      selectcolor: "#DBDFEA"
    },
    {
      image: [ImagePallete2],
      selectcolor: "#B7C4CF"
    },
    {
      image: [ImagePallete3],
      selectcolor: "#87CBB9"
    },
    {
      image: [ImagePallete4],
      selectcolor: "#A0BFE0"
    },
    {
      image: [ImagePallete5],
      selectcolor: "#D3CEDF"
    },
    {
      image: [ImagePallete6],
      selectcolor: "#FFDEDE"
    },
  ];
  export const Pallete0G = [ // first Palete logo gradient
    {
      color: "#FFEAD2"
    },
    {
      color: "#FFEAD2"
    },
    {
        color: "#F6DCBD"
    },
    {
        color: "#F6DCBD"
    },
    {
      color: "#F6DCBD"
    },
    {
      color: "#EBC9A1"
    },
    {
      color: "#EBC9A1"
    },
    {
      color: "#D4B48F"
    },
    {
      color: "#D4B48F"
    },
    {
      color: "#B49D82"
    },
    {
      color: "#B49D82"
    },
    {
      color: "#676D9F"
    },
    {
      color: "#676D9F"
    },
    {
      color: "#757CBC"
    },
    {
      color: "#757CBC"
    },
    {
      color: "#848ABF"
    },

    {
      color: "#848ABF"
    },
    {
      color: "#9BA0C8"
    },
    {
      color: "#9BA0C8"
    },
    {
      color: "#9BA0C8"
    },
    {
      color: "#ACB1D6"
    },
    {
      color: "#ACB1D6"
    },
  ];
  export const Pallete1G = [
    {
      color: "#EEE3CB"
    },
    {
      color: "#EEE3CB"
    },
    {
        color: "#E2D6BC"
    },
    {
        color: "#E2D6BC"
    },
    {
      color: "#E2D6BC"
    },
    {
      color: "#D1BF99"
    },
    {
      color: "#D1BF99"
    },
    {
      color: "#AE9D79"
    },
    {
      color: "#AE9D79"
    },
    {
      color: "#8D8270"
    },
    {
      color: "#8D8270"
    },
    {
      color: "#826155"
    },
    {
      color: "#826155"
    },
    {
      color: "#916F63"
    },
    {
      color: "#916F63"
    },
    {
      color: "#A58D84"
    },
    {
      color: "#A58D84"
    },
    {
      color: "#B7A393"
    },
    {
      color: "#B7A393"
    },
    {
      color: "#B7A393"
    },
    {
      color: "#D7C0AE"
    },
    {
      color: "#D7C0AE"
    },
  ];
  export const Pallete2G = [ 
    {
      color: "#B9EDDD"
    },
    {
      color: "#B9EDDD"
    },
    {
        color: "#AFDFD0"
    },
    {
        color: "#AFDFD0"
    },
    {
      color: "#AFDFD0"
    },
    {
      color: "#90DCC4"
    },
    {
      color: "#90DCC4"
    },
    {
      color: "#7DC8B5"
    },
    {
      color: "#7DC8B5"
    },
    {
      color: "#7AB5A6"
    },
    {
      color: "#7AB5A6"
    },
    {
      color: "#577D86"
    },
    {
      color: "#577D86"
    },
    {
      color: "#648891"
    },
    {
      color: "#648891"
    },
    {
      color: "#5094A7"
    },
    {
      color: "#5094A7"
    },
    {
      color: "#569DAA"
    },
    {
      color: "#569DAA"
    },
    {
      color: "#569DAA"
    },
    {
      color: "#57AAB9"
    },
    {
      color: "#57AAB9"
    },
  ];
  export const Pallete3G = [ 
    {
      color: "#C5DFF8"
    },
    {
      color: "#C5DFF8"
    },
    {
        color: "#B7D4EF"
    },
    {
        color: "#B7D4EF"
    },
    {
      color: "#B7D4EF"
    },
    {
      color: "#91B9DE"
    },
    {
      color: "#91B9DE"
    },
    {
      color: "#85A8CE"
    },
    {
      color: "#85A8CE"
    },
    {
      color: "#8FB1D1"
    },
    {
      color: "#8FB1D1"
    },
    {
      color: "#313B7A"
    },
    {
      color: "#313B7A"
    },
    {
      color: "#4A55A2"
    },
    {
      color: "#4A55A2"
    },
    {
      color: "#5774C2"
    },
    {
      color: "#5774C2"
    },
    {
      color: "#6585BF"
    },
    {
      color: "#6585BF"
    },
    {
      color: "#6585BF"
    },
    {
      color: "#7895CB"
    },
    {
      color: "#7895CB"
    },
  ];
  export const Pallete4G = [ 
    {
      color: "#F2D7D9"
    },
    {
      color: "#F2D7D9"
    },
    {
        color: "#EBCFD1"
    },
    {
        color: "#EBCFD1"
    },
    {
      color: "#EBCFD1"
    },
    {
      color: "#D6C5C7"
    },
    {
      color: "#D6C5C7"
    },
    {
      color: "#C3BFCE"
    },
    {
      color: "#C3BFCE"
    },
    {
      color: "#D3CEDF"
    },
    {
      color: "#D3CEDF"
    },
    {
      color: "#68798B"
    },
    {
      color: "#68798B"
    },
    {
      color: "#748DA6"
    },
    {
      color: "#748DA6"
    },
    {
      color: "#7E96AE"
    },
    {
      color: "#7E96AE"
    },
    {
      color: "#8BA5BF"
    },
    {
      color: "#8BA5BF"
    },
    {
      color: "#8BA5BF"
    },
    {
      color: "#9CB4CC"
    },
    {
      color: "#9CB4CC"
    },
  ];
  export const Pallete5G = [ 
    {
      color: "#FAF0E4"
    },
    {
      color: "#FAF0E4"
    },
    {
        color: "#EFE2D3"
    },
    {
        color: "#EFE2D3"
    },
    {
      color: "#EFE2D3"
    },
    {
      color: "#E2D2BF"
    },
    {
      color: "#E2D2BF"
    },
    {
      color: "#F1D7D7"
    },
    {
      color: "#F1D7D7"
    },
    {
      color: "#FEECEC"
    },
    {
      color: "#FEECEC"
    },
    {
      color: "#9BCDD2"
    },
    {
      color: "#9BCDD2"
    },
    {
      color: "#535353"
    },
    {
      color: "#535353"
    },
    {
      color: "#C87855"
    },
    {
      color: "#C87855"
    },
    {
      color: "#F58C5F"
    },
    {
      color: "#F58C5F"
    },
    {
      color: "#F58C5F"
    },
    {
      color: "#FFA781"
    },
    {
      color: "#FFA781"
    },
  ];